module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showContent) ? _c('div', {
    staticClass: "content-main",
    class: _vm.style
  }, [_vm._t("default")], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a28fea1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/MainContent.vue
// module id = 539
// module chunks = 225